import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const WISHLIST_JEWELRY_COLUMN_FIELDS = [
  null,
  "date",
  "SKU",
  "stock_id",
  "Item",
  "Collection",
  "Metal",
  "Stones",
  "Size",
  "price",
  "location",
  "customer_name",
];

export const WISHLIST_DIAMOND_COLUMN_FIELDS = [
  null,
  "date",
  "StockID",
  "Shape",
  "Carat",
  "Colour",
  "Clarity",
  "Cut",
  "Polish",
  "Symmetry",
  "Certification",
  "TagPrice",
  "location",
  "customer_name",
];

const NUMERIC_FIELDS = new Set(["price", "TagPrice", "Carat"]);

const DATE_FIELDS = new Set(["date"]);

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (DATE_FIELDS.has(field)) return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

const sortRows = (rows, sortConfig, columnFields) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = columnFields[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};

export const sortWishlistJewelryRows = (rows, sortConfig) =>
  sortRows(rows, sortConfig, WISHLIST_JEWELRY_COLUMN_FIELDS);

export const sortWishlistDiamondRows = (rows, sortConfig) =>
  sortRows(rows, sortConfig, WISHLIST_DIAMOND_COLUMN_FIELDS);
